import { DTODesignSystemVersionStats, DTODesignSystemVersionStatsQuery } from "../../../dto/design-systems/stats";
import { RequestExecutor } from "../../../transport/request-executor";

export class VersionStatsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  get(dsId: string, vId: string, query: DTODesignSystemVersionStatsQuery = {}) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/${vId}/stats`, DTODesignSystemVersionStats, {
      query: new URLSearchParams(query),
    });
  }
}
